import type { GatsbyBrowser, GatsbySSR } from "gatsby"
import { Link } from "gatsby"
import Hel from "@onestore/hel/dist/Hel"
import type Theme from "@onestore/hel/dist/typings/theme"
import { ThemeProvider } from "@ionos-web-design-system/react"
import type { DefaultTheme } from "styled-components"

export const wrapPageElementWithTheme = (
  brand: Theme.Brand,
  theme: DefaultTheme
): GatsbySSR["wrapPageElement"] | GatsbyBrowser["wrapPageElement"] => {
  return ({ element }) => (
    <Hel
      brand={brand}
      env={process.env.NODE_ENV as "development" | "production" | undefined}
      theme={theme}
      linkComponent={Link}
    >
      <ThemeProvider>{element}</ThemeProvider>
    </Hel>
  )
}

export const onRenderBody: GatsbySSR["onRenderBody"] = ({
  setHeadComponents,
}) => {
  setHeadComponents([
    <link
      key="overpass-font"
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Overpass:200,400,700,800&display=swap"
      crossOrigin="anonymous"
    />,
  ])
}
